import { IRankingResponse } from '../../interfaces/rankings-report.interface'

export interface RankingsReportsStateModel {
  reports: IRankingResponse
}
